import { createApp } from 'vue'
import axios from "@/plugins/axios";
import store from "@/store";
import installElementPlus from "@/plugins/element";
import elementIcon from "@/plugins/svgicon";
import permission from "@/plugins/permission";
import hasPermission from "@/plugins/hasPermission";
import mock from "@/plugins/mock";
// import directives from "@/directives";
import "nprogress/nprogress.css";
import "@/styles/common.scss";
import 'vant/lib/index.css';
import router from "@/router";
// import 'video.js/dist/video-js.css'
import vue3PhotoPreview from 'vue3-photo-preview';
import 'vue3-photo-preview/dist/index.css';
import App from './App.vue'
import i18nPlugin from "@/plugins/i18n";

const app = createApp(App);
app.use(i18nPlugin)
app.use(mock)
    .use(elementIcon)
    .use(installElementPlus)
    .use(store)
    .use(router)
    .use(vue3PhotoPreview, {
        // 配置图片预览的参数
        fullscreen: true, // 是否启用全屏
        download: false, // 是否启用下载
        rotate: false, // 是否启用旋转
      })
    .use(axios, { router, store, opt: "VE_API" })
    .use(permission, { router, store })
    .use(hasPermission)
    // .use(directives, { router, store });



app.mount("#app");
